import React from 'react'
import { Alert, Link, Stack, Typography } from '@mui/material'

export default function EmailPreview({ preview }) {
  const templateId = /^d-[a-f0-9]{32}$/.test(preview.templateId || '') ? preview.templateId : null
  return <Stack gap={2}>
    <Typography fontWeight={600}>{preview.subject}</Typography>
    {preview.recipient && <Typography variant="caption">To: {preview.recipient}</Typography>}
    {preview.version != null && <Typography variant="caption">Content version: {preview.version}</Typography>}
    <Alert severity="info">This is a text preview. Open the template in SendGrid to review the email layout. Changes made in SendGrid may change the final wording and appearance.</Alert>
    <Typography component="pre" sx={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', fontFamily: 'inherit', m: 0 }}>{preview.body}</Typography>
    <Link href="https://mc.sendgrid.com/dynamic-templates" target="_blank" rel="noopener noreferrer">Open SendGrid templates</Link>
    {templateId && <Typography variant="caption" color="text.secondary">Template ID: {templateId}</Typography>}
  </Stack>
}
